import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer
      className="border-t"
      style={{
        backgroundColor: "var(--footer-bg)",
        borderColor: "var(--footer-border)",
      }}
    >
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">

          {/* Brand — takes 2 cols */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 cursor-pointer mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/113546dc-a8c1-44fa-8aac-7a04c0cd68d4/a91fc359-a746-41f9-8206-b58c60059de3_unnamed.png?v=fe9bc73b1061e5aa513302540e5292fb"
                alt="TupIM"
                className="w-7 h-7 rounded-md object-cover"
              />
              <span className="font-bold text-base" style={{ color: "var(--text-primary)" }}>
                TupIM
              </span>
            </Link>
            <p className="text-sm leading-relaxed max-w-xs" style={{ color: "var(--text-muted)" }}>
              {t("footer.tagline")}
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-sm font-semibold mb-4" style={{ color: "var(--text-primary)" }}>
              {t("footer.col.product")}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/download/android"
                  className="text-sm transition-colors cursor-pointer"
                  style={{ color: "var(--text-muted)" }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "var(--accent)")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "var(--text-muted)")}
                >
                  {t("nav.android")}
                </Link>
              </li>
              <li>
                <Link
                  to="/download/ios"
                  className="text-sm transition-colors cursor-pointer"
                  style={{ color: "var(--text-muted)" }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "var(--accent)")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "var(--text-muted)")}
                >
                  {t("nav.ios")}
                </Link>
              </li>
              <li>
                <Link
                  to="/download/pc"
                  className="text-sm transition-colors cursor-pointer"
                  style={{ color: "var(--text-muted)" }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "var(--accent)")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "var(--text-muted)")}
                >
                  {t("nav.pc")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Developers */}
          <div>
            <h4 className="text-sm font-semibold mb-4" style={{ color: "var(--text-primary)" }}>
              {t("footer.col.developer")}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/docs"
                  className="text-sm transition-colors cursor-pointer"
                  style={{ color: "var(--text-muted)" }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "var(--accent)")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "var(--text-muted)")}
                >
                  {t("nav.serverApi")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Company + Language */}
          <div>
            <h4 className="text-sm font-semibold mb-4" style={{ color: "var(--text-primary)" }}>
              {t("footer.col.company")}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm transition-colors cursor-pointer"
                  style={{ color: "var(--text-muted)" }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "var(--accent)")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "var(--text-muted)")}
                  onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                >
                  {t("footer.link.about")}
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm transition-colors cursor-pointer"
                  style={{ color: "var(--text-muted)" }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "var(--accent)")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "var(--text-muted)")}
                  onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                >
                  {t("footer.link.contact")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div
          className="border-t mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3"
          style={{ borderColor: "var(--footer-border)" }}
        >
          <p className="text-xs" style={{ color: "var(--text-muted)" }}>
            {t("footer.copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
}